import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-03e4f220"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "content-back"
};
const _hoisted_3 = {
  class: "top-main"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "content-main"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "top-word-back"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "top-word"
}, [/*#__PURE__*/_createTextVNode(" 平台为防止用户被投资、理财、兼职、刷单、裸聊、色情等网络诈骗，制定了《防骗指南》为维护平台健康发展，为广大网友营造积极、健康的网络环境 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 我们希望每一位用户都能在平台上安全、愉快地交流与互动，共同营造一个健康、和谐的网络环境。如您遇到诈骗用户或内容，请立即举报，客服核实后，根据情节严重问题进行警告/封号/并将信息移交公安部门等方式处理 ")])], -1));

const _hoisted_8 = {
  class: "word"
};
const _hoisted_9 = ["src"];

const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<p class=\"small-title\" data-v-03e4f220>1、色情、裸聊诈骗</p> 这种诈骗通常以提供色情内容或进行裸聊为诱饵，吸引受害者参与。犯罪分子会在过程中通过各种手段获取受害者的隐私信息、钱财等。他们可能会以曝光裸聊视频等威胁手段，逼迫受害者不断转账汇款；或者以观看色情表演为由，要求受害者先支付费用，之后不断以各种理由索要更多钱。给受害者造成巨大的经济损失和精神压力。 <p class=\"small-title\" data-v-03e4f220>2、直播引流诈骗</p> 双方聊天时，会找理由让双方添加QQ/微信好友，然后以唱歌跳舞、线下见面为理由，诱导你转账打赏，然后将你拉黑删除。 <p class=\"small-title\" data-v-03e4f220>3、高薪招聘兼职、刷单诈骗</p> 这类诈骗中，犯罪分子打着高薪招聘兼职的幌子，吸引人们上钩。他们声称刷单可以轻松赚取高额报酬，一开始可能会给受害者一些小甜头，让受害者尝到返利的“好处”，然后诱导受害者不断加大投入刷单的金额。但当受害者想要提现时，犯罪分子就会以各种理由拖延、拒绝，甚至直接拉黑消失，让受害者遭受巨大的经济损失。 <p class=\"small-title\" data-v-03e4f220>4、杀猪盘、投资诈骗</p> 在这种诈骗中，犯罪分子伪装成高富帅或白富美与受害者网恋，取得受害者的信任，将受害者当成“待宰的猪”。等关系稳定后，然后说自己掌握了某个稳赚不赔的投资渠道，让受害者一起参与。诱导受害者向虚假的投资平台注入资金。一开始，受害者可能会看到一些虚假的收益回报，以为真的赚到了钱，从而放松警惕并加大投资。然而，当受害者想要提现时，就会发现根本无法操作，此时犯罪分子早已卷款潜逃。 <p class=\"small-title\" data-v-03e4f220>5、还有酒托、饭托、游戏托、微商等等...</p> 拉你进同城群，与群里的托互相配合骗取钱财。交友见面要求发送包，打车交通费涉及资金的都要小心。骗术还有很多且层出不穷，但记住，一上来就让你转账的，大概率是骗子 ", 10);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.arr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "back-div"
    });
  }), 128)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $setup.preventWord,
    class: "prevent-word"
  }, null, 8, _hoisted_4), _createElementVNode("img", {
    src: $setup.preventIcon,
    class: "prevent-icon"
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("img", {
    src: $setup.preventLock,
    class: "prevent-lock"
  }, null, 8, _hoisted_9), _hoisted_10])])])]);
}